import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Offer } from '../../documents/document.contract';
import { FormsModule } from '@angular/forms';
import * as api from '../../shared/api/apihandler';

@Component({
  selector: 'app-offer-search',
  templateUrl: './offer-search.component.html',
  styleUrls: ['./offer-search.component.css'],
})

export class OfferSearchComponent implements OnInit, OnChanges {

  @Output('offer') chosen = new EventEmitter();
  @Input('options') options = new OfferSearchOutputOptions();
  @Input('offerId') offerId = '';
  @Input() inputId: string = 'standard';
  @Input('addFrom') addFrom = false;
  allOffers: Array<Offer> = [];
  output: Array<Offer> = [];
  whichOffer: string = '';
  gettingOffers = false;
  offset = -240;
  chosenOffer: Offer = null;
  isSearching = false;
  viewAmount = 10;
  allowChange = true;
  constructor(private httpClient: HttpClient) {
  }

  ngOnInit() {
    this.getOffers();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!!changes.offerId) {
      if (changes.offerId.currentValue != null && this.chosenOffer != null && this.chosenOffer.offerId != changes.offerId.currentValue || changes.offerId.currentValue != null && this.chosenOffer == null) {
        this.getOffers();
      } else if (!!changes.offerId && changes.offerId.currentValue == null && this.chosenOffer != null) {
        this.chosenOffer = null;
      }
    }
  }

  getOffers() {
    this.gettingOffers = true;
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/Website/Offer', { headers }).subscribe((data: Array<Offer>) => {
      this.allOffers = data;
    },
      () => { },
      () => {
        this.gettingOffers = false;
        if (this.offerId != null) {
          this.chosenOffer = this.allOffers.find(x => x.offerId == this.offerId);
        }
        //this.search();
      }
    )
  }

  close() {
    let a = document.getElementById('searchOfferModal' + this.inputId);
    a.click();
    this.isSearching = false;
  }

  async search() {
    if (this.allOffers.length == 0 && !this.gettingOffers) {
      this.getOffers();
    }
    else if (this.allOffers.length > 0 && !this.gettingOffers && this.whichOffer != '') {
      var s = this.whichOffer.toLowerCase();
      let result = await this.allOffers.filter(x =>
        !!x.offerNumber && x.offerNumber.toString().toLowerCase().match(s) ||
        !!x.customer && x.customer.address != null && x.customer.address.toLowerCase().match(s) ||
        !!x.customer && x.customer.name != null && x.customer.name.toLowerCase().match(s) ||
        !!x.customer && x.customer.zipCode != null && x.customer.zipCode.toLowerCase().match(s) ||
        !!x.customer && x.customer.city != null && x.customer.city.toLowerCase().match(s) ||
        x.title != null && x.title.toLowerCase().match(s) ||
        x.description != null && x.description.toLowerCase().match(s) ||
        x.responsible.value != null && x.responsible.value.toLowerCase().match(s)
      )
      this.restrictViewAmount(result)
    }
    else {
      this.restrictViewAmount(this.allOffers);
    }
  }
  restrictViewAmount(array) {
    if (array.length > this.viewAmount) {
      this.output = array.slice(0, this.viewAmount);
    }
    else { this.output = array; }
  }

  chooseOffer(o: Offer) {
    if (!this.options.forgetSelected) { this.chosenOffer = o; }
    this.output = [];
    if (o != null) {
      this.chosen.emit(o)
    }
  }

}

export class OfferSearchOutputOptions {
  offset: number = 0;
  maxHeight: number = 70;
  bottom: number = null;
  preselected: string = null;
  forgetSelected: boolean = false;
  buttonClass: string = null;
  customButtonText: string = null;
  hideOpener:false;
}
